/* Progressive collection loading; the next-page link remains usable if loading fails. */
let monaruPageObserver;
async function loadItems(control) {
  if (!control || control.dataset.loading === 'true') return;
  const scope = control.closest('.collection-grid-section') || document;
  const grid = scope.querySelector('.load-more-grid');
  const nextInput = scope.querySelector('[data-next-url]');
  const next = nextInput?.value || control.getAttribute('href');
  if (!grid || !next) return;
  const status = scope.querySelector('.monaru-load-status');
  control.dataset.loading = 'true';
  control.setAttribute('aria-disabled','true');
  if (status) status.textContent = status.dataset.loading;
  try {
    const response = await fetch(next,{headers:{'Accept':'text/html'}});
    if (!response.ok) throw new Error('HTTP '+response.status);
    const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
    const newGrid = parsed.querySelector('.load-more-grid');
    if (!newGrid) throw new Error('Product grid unavailable');
    if (!grid.isConnected || !control.isConnected) return;
    grid.append(...newGrid.children);
    const nextUrl = parsed.querySelector('[data-next-url]')?.value;
    if (nextUrl) {
      nextInput.value = nextUrl;
      control.href = nextUrl;
      if (control.classList.contains('js-infinite-scroll')) monaruPageObserver?.observe(control);
    } else { control.remove(); nextInput.remove(); }
    if (status) status.textContent = '';
    if (typeof colorSwatches === 'function') colorSwatches();
  } catch {
    if (status) status.textContent = status.dataset.error;
    // Do not auto-retry a failed request. The visible link lets the shopper retry.
  } finally {
    control.dataset.loading = 'false';
    control.removeAttribute('aria-disabled');
  }
}
function checkVisibility() {
  monaruPageObserver?.disconnect();
  if (!('IntersectionObserver' in window)) return;
  monaruPageObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { monaruPageObserver.unobserve(entry.target); loadItems(entry.target); } });
  },{rootMargin:'300px 0px'});
  document.querySelectorAll('.js-infinite-scroll').forEach(element => monaruPageObserver.observe(element));
}
function loadMore() {
  document.querySelectorAll('.js-load-more,.js-infinite-scroll').forEach(control => {
    control.onclick = event => { event.preventDefault(); loadItems(control); };
  });
  checkVisibility();
}
loadMore();
